import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
      <p> © Copyright 2024 - Seher. All Rights Reserved.</p>
    </div>
  )
}

export default Footer
